import { render, staticRenderFns } from "./ResetPassWord.vue?vue&type=template&id=28ee3411&scoped=true&"
import script from "./ResetPassWord.vue?vue&type=script&lang=js&"
export * from "./ResetPassWord.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassWord.vue?vue&type=style&index=0&id=28ee3411&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee3411",
  null
  
)

export default component.exports